import http from '../../../base/api/public'
let service = require('@/../config/serviceList');
let sysConfig = require('@/../config/sysConfig');
let apiPre = sysConfig.apiPre;
export default {

  getChargeAnalyseData (params) {
    return http.requestPost(apiPre + service.order + '/order/statistic/businessCenterStatistic', params)
  }

}



// WEBPACK FOOTER //
// ./src/module/dataCenter/api/businessCenter.js